import useOrbitChatSuggestions from '../../data/orbit/useOrbitChatSuggestions';
import { Alert } from '../base/Alert';
import { LoadingWheel } from '../base/LoadingWheel';

interface ChatSuggestionsProps {
  onSuggestionClick: (suggestion: string) => void;
}

export function ChatSuggestions({ onSuggestionClick }: ChatSuggestionsProps) {
  const { suggestions } = useOrbitChatSuggestions();

  if (suggestions.isLoading) {
    return (
      <div className="flex flex-row items-center justify-center space-x-2 text-gray-800 dark:text-gray-200">
        <LoadingWheel size="sm" />
        <span>Loading suggestions...</span>
      </div>
    );
  }

  if (suggestions.isError) {
    return <Alert className="mx-10" severity="error" message="Error getting chat suggestions" />;
  }

  return (
    <ul className="self-end mx-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
      {suggestions.data?.map((suggestion, i) => (
        <li
          key={i}
          style={{ animationDelay: `${i * 60}ms` }}
          className="py-2 px-4 rounded-md text-gray-800 border border-gray-200 bg-gray-100 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 hover:bg-gray-300 hover:text-black dark:hover:bg-gray-600 dark:hover:text-white hover:cursor-pointer transition-colors duration-150 animate-[suggestion-pop_0.3s_ease-out_both]"
          onClick={() => onSuggestionClick(suggestion)}
        >
          {suggestion}
        </li>
      ))}
    </ul>
  );
}
